import { ComponentProps, forwardRef } from "react";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { useStyles } from "./styles";

type Props = ComponentProps<typeof Card>;

const LandingPageCard = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const styles = useStyles();
  return <Card {...props} ref={ref} className={styles.root} />;
});

export default LandingPageCard;
